import tw from 'tailwind-styled-components'

export const ModalContent = tw.div`
    flex flex-col gap-10 text-center justify-center p-20 max-w-400
`

export const Heading = tw.div`
   linerGradientText text-2xl font-bold text-center
`

export const ProgressBarWrap = tw.div`
    flex flex-row gap-10
`

export const TimerWrapper = tw.div`
    text-xs text-white font-bold
`

export const SocialSection = tw.div`
    flex flex-col items-center gap-10
`

export const SocialSectionHeading = tw.p`
    font-medium text-footerDarkGray text-sm
`
